export default function(obj) {
    const formData = new FormData();
    for(let k in obj) {
        formData.append( k, obj[k] );
    }

    return formData;
}
